import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getGroupLifeContractList, getProductSummary } from '../../../../global/ducks/mlps-api';
import { TcsmStates } from '../../../../root/tcsm-model';
import { setGroupLifeContractList, setProductSummary } from './document-download-slice';


export function useDocumentDownloadState() {
	const dispatch = useDispatch();
	const groupId = useSelector<TcsmStates, number>(state => state.groupsState?.currentGroup?.group_id);
	const loaded = useSelector<TcsmStates, boolean>(state => state.documentDownload?.documentsLoaded && state.documentDownload?.groupLifeContractListLoaded );

	useEffect(() => {
		if (groupId) {
			dispatch(getProductSummary(groupId, (data) => dispatch(setProductSummary(data))));
			dispatch(getGroupLifeContractList(groupId, (data) => dispatch(setGroupLifeContractList(data))));
		}
	}, [groupId]);

	return loaded;
}
